// import { shuffle } from 'lodash';

// import { GraphicsV2SourceType } from '../../components/Atoms/Graphics';
// import { IconType } from '../../constants/icons';
import { DefaultColors } from '../../constants/Theme/DefaultColors';
import { GameType } from '../../models/GameStore';
// import { NonEmptyArray } from '../../models/Utils';

export type ThemeType = 'competition' | 'challenge' | GameType;
export type Theme = {
  // portraitBackground: GraphicsV2SourceType;
  // landscapeBackground: GraphicsV2SourceType;
  // Plate?: GraphicsV2SourceType;
  primaryColor?: string;
  secondaryColor?: string;
};

// export const GAME_THEME = Object.freeze<
//   {
//     themeTypes: ThemeType[];
//     themes: NonEmptyArray<Theme>;
//   }[]
// >([
//   {
//     themeTypes: ['competition'],
//     themes: [
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/competition_bg1_1450x667.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/Competition_BG_Stadium.png'),
//       },
//     ],
//   },
//   {
//     themeTypes: ['challenge'],
//     themes: [
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/challenge_bg1_1450x667.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/challenge_bg1_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/challenge_bg2_1450x667.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/challenge_bg2_1450x667.png'),
//       },
//     ],
//   },
//   {
//     themeTypes: [
//       GameType.TextOrdering,
//       GameType.Ordering,
//       GameType.Conversation,
//       // GameType.Speaking,
//       GameType.ManuallyEvaluatedConversation,
//     ],
//     themes: [
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/speaking_game_bg1_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/speaking_game_bg1_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/speaking_game_bg2_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/speaking_game_bg2_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/speaking_game_bg3_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/speaking_game_bg3_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/spelling_game_bg1_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/spelling_game_bg1_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/spelling_game_bg2_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/spelling_game_bg2_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/spelling_game_bg3_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/spelling_game_bg3_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/word_game_bg1_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/word_game_bg1_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/word_game_bg2_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/word_game_bg2_1450x667.png'),
//       },
//     ],
//   },
//   {
//     themeTypes: [GameType.MultipleChoice, GameType.Matching],
//     themes: [
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/matching_game_bg_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/matching_game_bg_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/matching_game_bg2_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/matching_game_bg2_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/multiple_choice_game_bg_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/multiple_choice_game_bg_1450x667.png'),
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/multiple_choice_game_bg2_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/multiple_choice_game_bg2_1450x667.png'),
//       },
//     ],
//   },
//   {
//     themeTypes: [GameType.FingerWriting],
//     themes: [
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/handwriting_game_bg1_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/handwriting_game_bg1_1450x667.png'),
//         primaryColor: DefaultColors.gray.VERY_LIGHT_GRAY_80,
//         secondaryColor: DefaultColors.gray.VERY_LIGHT_GRAY_80,
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/handwriting_game_bg2_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/handwriting_game_bg2_1450x667.png'),
//         primaryColor: DefaultColors.gray.VERY_LIGHT_GRAY_80,
//         secondaryColor: DefaultColors.gray.VERY_LIGHT_GRAY_80,
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/handwriting_game_bg3_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/handwriting_game_bg3_1450x667.png'),
//         primaryColor: DefaultColors.gray.VERY_LIGHT_GRAY_80,
//         secondaryColor: DefaultColors.gray.VERY_LIGHT_GRAY_80,
//       },
//     ],
//   },
//   {
//     themeTypes: [GameType.Pairing],
//     themes: [
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/listening_game_bg01_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/listening_game_bg01_1450x667.png'),
//         Plate: IconType.Plate1,
//       },
//       {
//         portraitBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/listening_game_bg02_667x1450.png'),
//         landscapeBackground: require<ImageRequireSource>('assets/graphics/png/game/backgrounds/listening_game_bg02_1450x667.png'),
//         Plate: IconType.Plate2,
//       },
//     ],
//   },
// ]);

export const GAME_THEME_COLOR = Object.freeze<
  [
    {
      backgroundColor: string;
      arrow: string;
    },
    {
      backgroundColor: string;
      arrow: string;
    },
    {
      backgroundColor: string;
      arrow: string;
    },
    {
      backgroundColor: string;
      arrow: string;
    },
    {
      backgroundColor: string;
      arrow: string;
    },
    {
      backgroundColor: string;
      arrow: string;
    },
  ]
>([
  {
    backgroundColor: DefaultColors.red.CC_LIGHT_RED,
    arrow: DefaultColors.red.CC_ARROW_PINK,
  },
  {
    backgroundColor: DefaultColors.orange.CC_LIGHT_ORANGE,
    arrow: DefaultColors.orange.CC_ARROW_ORANGE,
  },
  {
    backgroundColor: DefaultColors.yellow.CC_LIGHT_YELLOW,
    arrow: DefaultColors.yellow.CC_ARROW_YELLOW,
  },
  {
    backgroundColor: DefaultColors.green.CC_LIGHT_GREEN,
    arrow: DefaultColors.green.CC_ARROW_GREEN,
  },
  {
    backgroundColor: DefaultColors.blue.CC_LIGHT_BLUE,
    arrow: DefaultColors.blue.CC_ARROW_LIGHT_BLUE,
  },
  {
    backgroundColor: DefaultColors.purple.CC_LIGHT_PURPLE,
    arrow: DefaultColors.purple.CC_ARROW_PURPLE,
  },
]);

// export const getGameThemeBackground = (
//   theme: ThemeType,
//   seed?: number,
// ): Theme => {
//   const themeMap = GAME_THEME.reduce(
//     (acc, { themeTypes, themes }) => {
//       const t =
//         seed !== undefined
//           ? [
//               ...themes.slice(seed % themes.length),
//               ...themes.slice(0, seed % themes.length),
//             ]
//           : shuffle(themes);
//       themeTypes.forEach((themeType, i) => {
//         acc[themeType] = t[i % themes.length] as Theme;
//       });
//       return acc;
//     },
//     {} as Record<ThemeType, Theme>,
//   );
//   return themeMap[theme] ?? themeMap.competition;
// };

export const getRandomGameThemeType = (): GameType => {
  const type = [
    GameType.TextOrdering,
    // GameType.Ordering,
    // GameType.Speaking,
    // GameType.MultipleChoice,
    // GameType.Matching,
    GameType.FingerWriting,
    // GameType.Pairing,
    // GameType.Conversation,
    // GameType.ManuallyEvaluatedConversation,
  ];
  return type[Math.floor(Math.random() * type.length)] as GameType;
};

// export const getDefaultGameTypeBackground = (
//   gameType: GameType,
// ): GraphicsV2SourceType => {
//   const t = GAME_THEME.reduce(
//     (acc, { themeTypes, themes }) => {
//       themeTypes.forEach((themeType, i) => {
//         acc[themeType] = themes[i % themeTypes.length] as Theme;
//       });
//       return acc;
//     },
//     {} as Record<ThemeType, Theme>,
//   );
//   return t[gameType].landscapeBackground;
// };
